/**
 * Error page component.
 */

import { Link, useLocation } from 'react-router-dom';

export default function Error() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const errorId = params.get('id');
  const errorMessage = params.get('error');

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="card max-w-md w-full text-center">
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-red-600 dark:text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>

        <h1 className="text-2xl font-bold text-content-primary mb-2">
          {errorMessage ? 'Error' : 'Page Not Found'}
        </h1>

        <p className="text-content-secondary mb-6">
          {errorMessage || "The page you're looking for doesn't exist or has been moved."}
        </p>

        {errorId && (
          <p className="text-xs text-content-tertiary mb-4">
            Error ID: {errorId}
          </p>
        )}

        <div className="flex justify-center space-x-4">
          <Link to="/login" className="btn-primary">
            Go to Login
          </Link>
          <button
            onClick={() => window.history.back()}
            className="btn-secondary"
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}
